import {
  AgentAssignmentFilterEnum,
  AttachmentsFilterEnumMap,
  Filter,
  IFilters,
  NotTaggedFilterId,
  RatingFilter,
} from "constants/filters";
import { ensureArray, ensureFlat } from "helpers/data";
import { deserializeCustomDateRangeURLParams } from "helpers/filters";
import { TicketSilo, TicketStatus } from "interfaces/entities/ticket";
import { serializeFilters } from "services/api/ticket/ticket-api";
import { CustomViewAuthor, ICustomView } from "store/entities/custom-views/interfaces";

export default {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deserialize(view: Record<string, any>): ICustomView {
    return {
      id: view.ID,
      name: view.name,
      filters: deserializeFilters(view.filters),
      createdBy: view.createdBy,
      agentID: view.agentID,
      createdByType: view.createdByType as CustomViewAuthor,
      createdAt: view.createdAt,
    };
  },

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deserializeCollection(views: Record<string, any>[]): ICustomView[] {
    return views.map(view => this.deserialize(view));
  },

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  serialize(customView: Partial<ICustomView>): Record<string, any> {
    return {
      name: customView.name,
      // @ts-expect-error TS(2345)
      filters: serializeFilters(customView.filters),
      ...(customView.shared !== undefined ? { shared: customView.shared } : {}),
    };
  },
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function deserializeFilters(responseFilters: Record<string, any>): IFilters {
  const filters: IFilters = {};

  filters[Filter.Silo] = responseFilters.silo || TicketSilo.Tickets;

  const creationDateRangeFilter = deserializeCustomDateRangeURLParams(
    responseFilters.createdDateFrom as string,
    responseFilters.createdDateTo as string
  );
  if (creationDateRangeFilter) {
    filters[Filter.CreationDateRange] = creationDateRangeFilter;
  }

  const lastActivityRangeFilter = deserializeCustomDateRangeURLParams(
    responseFilters.updatedDateFrom as string,
    responseFilters.updatedDateTo as string
  );
  if (lastActivityRangeFilter) {
    filters[Filter.LastActivityDateRange] = lastActivityRangeFilter;
  }

  const lastMessageRangeFilter = deserializeCustomDateRangeURLParams(
    responseFilters.lastMessageFrom as string,
    responseFilters.lastMessageTo as string
  );
  if (lastMessageRangeFilter) {
    filters[Filter.LastMessageDateRange] = lastMessageRangeFilter;
  }

  if (responseFilters.status) {
    filters[Filter.TicketStatus] = ensureArray(responseFilters.status) as TicketStatus[];
  }

  if (responseFilters.spam) {
    filters[Filter.TicketStatus] = ensureArray([
      ...(responseFilters.status ? ensureArray(responseFilters.status) : []),
    ]) as TicketStatus[];
  }

  if (responseFilters.assignment && responseFilters.assignment.agent) {
    filters[Filter.Agent] = ensureArray(responseFilters.assignment.agent.ID);
  }

  if (typeof responseFilters.priority === "number" || Array.isArray(responseFilters.priority)) {
    filters[Filter.Priority] = {
      priority: ensureArray(responseFilters.priority),
      ...(responseFilters.priorityOp ? { priorityOp: responseFilters.priorityOp } : {}),
    };
  }

  if (responseFilters.hasAssignee !== undefined) {
    filters[Filter.AgentAssignment] = ensureArray(
      ensureFlat(responseFilters.hasAssignee)
        ? AgentAssignmentFilterEnum.Assigned
        : AgentAssignmentFilterEnum.Unassigned
    );
  }

  if (responseFilters.hasAttachments !== undefined) {
    filters[Filter.Attachments] = ensureArray(
      // @ts-expect-error TS(7053)
      AttachmentsFilterEnumMap.fromQueryString[ensureFlat(responseFilters.hasAttachments)]
    );
  }

  if (responseFilters.assignment && responseFilters.assignment.team) {
    filters[Filter.Group] = ensureArray(responseFilters.assignment.team.ID);
  }

  if (responseFilters.tagIDs) {
    filters[Filter.Tag] = ensureArray(responseFilters.tagIDs);
  }

  if (responseFilters.hasTags !== undefined) {
    filters[Filter.Tag] = [...(responseFilters.tagIDs ? ensureArray(responseFilters.tagIDs) : []), NotTaggedFilterId];
  }

  if (responseFilters.rate) {
    filters[Filter.Rating] = ensureArray(responseFilters.rate) as RatingFilter[];
  }

  if (responseFilters.detailedSource) {
    filters[Filter.DetailedSource] = ensureArray(responseFilters.detailedSource);
  }

  if (responseFilters.follower) {
    filters[Filter.Followers] = ensureArray(responseFilters.follower);
  }

  if (responseFilters.language) {
    filters[Filter.Language] = ensureArray(responseFilters.language);
  }

  return filters;
}
